import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Password} from 'primereact/password';


class CasPassword extends Component {
    
    static propTypes = {
        id:PropTypes.string,
        type:PropTypes.any,
        size:PropTypes.number,
        name:PropTypes.string.isRequired,
        value:PropTypes.any,
        disabled:PropTypes.bool,
        onChange:PropTypes.func.isRequired,
        tooltip: PropTypes.any,
        className: PropTypes.string,
        style: PropTypes.any,
        onInput:PropTypes.func,
        maxLength:PropTypes.number,
        tabindex:PropTypes.number,
        label:PropTypes.string,
        errorText:PropTypes.string,
        placeholder:PropTypes.string,
    }

    static defaultProps = {
        disabled: false,
        id:'',
        name:'',
        value:'',
        maxLength:100,
        tabindex:2,
        label:"",
        errorText:"",
        placeholder:""
    };

 
    renderErrorText() {
      if(this.props.errorText){
        return(
          <small className="cas-inline-err-text p-d-block">{this.props.errorText}</small>
        );
      }
    }

    renderField() {
      const {
        id,
        type,
        name,
        size,
        value,
        disabled,
        onChange,
        tooltip,
        style,
        maxLength,
        tabindex,
        onFocus,
        onBlur,
        placeholder,
        onInput
        
      } = this.props;
      let className = this.props.className;
      if(this.props.errorText){
        className = className + " p-invalid";
      }
      return (
        <Password id={id} placeholder={placeholder} className={className}  type={type} size={size} value={value} name={name} onChange={onChange} disabled={disabled} 
           onInput={onInput} tooltip={tooltip} onFocus={onFocus} onBlur={onBlur} style={style} maxLength={maxLength}  tabIndex={tabindex} feedback={false} />
      )
    }

    render () {
      return (
        <div className="cas-input-field">
          {this.renderField()}
          {this.renderErrorText()}
        </div>
      )
    }

  }

export default CasPassword;
